import PropTypes from 'prop-types';
import { FlexGrid, Header, Text } from '@gasbuddy/react-components';

import styles from './GuideStep.module.css';

const GuideStep = ({ step }) => (
  <FlexGrid className={styles.stepContainer}>
    <FlexGrid.Column mobile={2}>
      <div className={styles.stepNumberContainer}>
        <Text bold centered color="white">{step.stepText}</Text>
      </div>
    </FlexGrid.Column>
    <FlexGrid.Column mobile={10}>
      <Header as="h3" className={styles.header} uppercase>{step.header}</Header>
      <Text className={styles.content}>{step.content}</Text>
    </FlexGrid.Column>
  </FlexGrid>
);

GuideStep.propTypes = {
  step: PropTypes.shape({
    content: PropTypes.string,
    header: PropTypes.string,
    stepText: PropTypes.string,
  }),
};

GuideStep.defaultProps = {
  step: {},
};

export default GuideStep;
